<template>
    <div class="bg-[#23242A] h-full ">
        <div class="table-loading" v-if="loading">
            <block-loading />
        </div>
        <div class="p-3 custom-full custom-left" v-else-if="error"><p  class="text-center text-theme-red">No Data found.</p></div>
        <div v-else>
            <div class="pt-[16px] px-[24px] max-w-full">
                <div class="flex justify-between shadow-xl box-border items-center text-white h-[62px] rounded p-4 bg-[#2B2C32] mb-4">
                    <div class="flex items-center">
                        <svg @click="saveAndGoBack()" class="cursor-pointer" width="20" height="20" vie wBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 8.75H4.7875L11.775 1.7625L10 0L0 10L10 20L11.7625 18.2375L4.7875 11.25H20V8.75Z" fill="white"/>
                        </svg>
                        <h1 class="font-bold ml-3 text-2xl leading-[30px] tracking-[0.05px]">{{payload.toLocationId ? form.name.value : "New Inventory Transfer"}}</h1>
                    </div>
                    <div class="flex items-center">
                        <div class="flex items-center border-r border-[#464851] pr-4">
                            <select v-if="$route.query.status && $route.query.status==='shipped'" v-model="form.status.value" class="cursor-pointer w-[200px] h-[40px] bg-[#464851] border-[#464851] focus:outline-0 font-normal text-base leading-5 text-white p-2 rounded">
                                <option value="shipped transfer">Shipped Transfer</option>
                                <option disabled value="completed transfer">Completed Transfer</option>
                            </select>
                            <select v-else-if="$route.query.status && $route.query.status==='pending'" v-model="form.status.value" class="cursor-pointer w-[200px] h-[40px] bg-[#464851] border-[#464851] focus:outline-0 font-normal text-base leading-5 text-white p-2 rounded">
                                <option value="pending">Pending</option>
                                <option value="shipped transfer">Shipped Transfer</option>
                            </select>
                            <select v-else v-model="form.status.value" class="cursor-pointer w-[200px] h-[40px] bg-[#464851] border-[#464851] focus:outline-0 font-normal text-base leading-5 text-white p-2 rounded">
                                <option disabled value="completed transfer">Completed Transfer</option>
                            </select>
                        </div>
                        <div class="flex items-center pl-4">
                            <button @click.prevent="goBack" class="flex justify-center items-center text-center w-[100px] h-[40px] p-4 border hover:border-theme-green text-[#9E9E9E] border-[#9E9E9E] hover:bg-theme-green hover:text-white rounded font-medium text-sm leading-[17.5px] tracking-[0.15px] mr-6">CANCEL</button>
                            <button :disabled="$route.query.status==='shipped' || $route.query.status==='completed'" @click.prevent="save" class="flex justify-center items-center text-center w-[100px] h-[40px] p-4 disabled:bg-theme-grey hover:opacity-60 bg-theme-green text-white rounded font-medium text-sm leading-[17.5px] tracking-[0.15px]">SAVE</button>
                        </div>
                    </div>
                </div>
            </div>
        
            <div class="h-[calc(100vh_-_100px)] overflow-y-auto">
                <!-- Transfer details -->
                <div class=" px-[24px] max-w-full">
                    <div class=" shadow-xl box-border items-center text-white rounded p-4 bg-[#2B2C32] mb-4">
                        <h2 class="font-bold  text-xl leading-6 tracking-[0.15px]">Transfer Details</h2>
                        <div class="flex gap-3 xl:flex-row flex-col items-start mt-[35px] mb-4">
                            <div class="w-full xl:w-1/2">
                                <div :class="'input-wrapper flex flex-col ' + (form.name.error_type)">
                                    <label class="text-xs mb-1">Transfer Name *</label>
                                    <input :disabled="$route.query.status!=='pending'" @keyup="validateFields(['name'])" v-model="form.name.value" placeholder="X-mas Quick Transfer" class="placeholder-[#9E9E9E] pointer-events-none h-[40px] block border-none rounded bg-[#1C1D21] w-full text-sm text-theme-white disabled:bg-[#1C1D21]" type="text">
                                    <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
                                </div>
                            </div>
                            <div class="w-full xl:w-1/2">
                                <div :class="'input-wrapper flex flex-col ' + (form.fromLocationId.error_type)">
                                    <label class="text-xs mb-1">Transfer From *</label>
                                    <select @change="validateFields(['fromLocationId'])" v-model="form.fromLocationId.value" class="pointer-events-none  w-full h-[40px] bg-[#1C1D21] border-0 focus:outline-0 font-normal text-sm leading-5 text-white p-2 rounded ">
                                        <option value="">Select a store</option>
                                        <option v-for="each in vg_locations" :key="each.id" :value="each.id">{{each.name}}</option>
                                    </select>
                                    <p class="field-error label-text mt-1" v-if="form.fromLocationId.error_message" v-text="form.fromLocationId.error_message"></p>
                                </div>
                            </div>
                            <div class="w-full xl:w-1/2">
                                <div :class="'input-wrapper deepa flex flex-col ' + (form.toLocationId.error_type)">
                                    <label class="text-xs mb-1">Transfer To *</label>
                                    <select @change="validateFields(['toLocationId'])" v-model="form.toLocationId.value" :class="payload.toLocationId ? 'pointer-events-none bg-[#1C1D21] border-0' : 'cursor-pointer bg-[#464851] border-[#464851]'" class="w-full h-[40px] focus:outline-0 font-normal text-base leading-5 text-white p-2 rounded">
                                        <option value="">Select a store</option>
                                        <template v-for="each in vg_locations">
                                            <option v-if="each.id!==form.fromLocationId.value" :key="each.id" :value="each.id">{{each.name}}</option>
                                        </template>
                                    </select>
                                    <p class="field-error label-text mt-1" v-if="form.toLocationId.error_message" v-text="form.toLocationId.error_message"></p>
                                </div>
                            </div>
                            <div class="w-full xl:w-1/2">
                                <div class="input-wrapper flex flex-col ">
                                    <p class="text-xs mb-1">Created On</p>
                                    <div class="relative">
                                        <div class="absolute px-2 top-[10px]">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 11.667C9.76389 11.667 9.56597 11.5871 9.40625 11.4274C9.24653 11.2677 9.16667 11.0698 9.16667 10.8337C9.16667 10.5975 9.24653 10.3996 9.40625 10.2399C9.56597 10.0802 9.76389 10.0003 10 10.0003C10.2361 10.0003 10.434 10.0802 10.5937 10.2399C10.7535 10.3996 10.8333 10.5975 10.8333 10.8337C10.8333 11.0698 10.7535 11.2677 10.5937 11.4274C10.434 11.5871 10.2361 11.667 10 11.667ZM6.66667 11.667C6.43056 11.667 6.23264 11.5871 6.07292 11.4274C5.91319 11.2677 5.83333 11.0698 5.83333 10.8337C5.83333 10.5975 5.91319 10.3996 6.07292 10.2399C6.23264 10.0802 6.43056 10.0003 6.66667 10.0003C6.90278 10.0003 7.10069 10.0802 7.26042 10.2399C7.42014 10.3996 7.5 10.5975 7.5 10.8337C7.5 11.0698 7.42014 11.2677 7.26042 11.4274C7.10069 11.5871 6.90278 11.667 6.66667 11.667ZM13.3333 11.667C13.0972 11.667 12.8993 11.5871 12.7396 11.4274C12.5799 11.2677 12.5 11.0698 12.5 10.8337C12.5 10.5975 12.5799 10.3996 12.7396 10.2399C12.8993 10.0802 13.0972 10.0003 13.3333 10.0003C13.5694 10.0003 13.7674 10.0802 13.9271 10.2399C14.0868 10.3996 14.1667 10.5975 14.1667 10.8337C14.1667 11.0698 14.0868 11.2677 13.9271 11.4274C13.7674 11.5871 13.5694 11.667 13.3333 11.667ZM10 15.0003C9.76389 15.0003 9.56597 14.9205 9.40625 14.7607C9.24653 14.601 9.16667 14.4031 9.16667 14.167C9.16667 13.9309 9.24653 13.733 9.40625 13.5732C9.56597 13.4135 9.76389 13.3337 10 13.3337C10.2361 13.3337 10.434 13.4135 10.5937 13.5732C10.7535 13.733 10.8333 13.9309 10.8333 14.167C10.8333 14.4031 10.7535 14.601 10.5937 14.7607C10.434 14.9205 10.2361 15.0003 10 15.0003ZM6.66667 15.0003C6.43056 15.0003 6.23264 14.9205 6.07292 14.7607C5.91319 14.601 5.83333 14.4031 5.83333 14.167C5.83333 13.9309 5.91319 13.733 6.07292 13.5732C6.23264 13.4135 6.43056 13.3337 6.66667 13.3337C6.90278 13.3337 7.10069 13.4135 7.26042 13.5732C7.42014 13.733 7.5 13.9309 7.5 14.167C7.5 14.4031 7.42014 14.601 7.26042 14.7607C7.10069 14.9205 6.90278 15.0003 6.66667 15.0003ZM13.3333 15.0003C13.0972 15.0003 12.8993 14.9205 12.7396 14.7607C12.5799 14.601 12.5 14.4031 12.5 14.167C12.5 13.9309 12.5799 13.733 12.7396 13.5732C12.8993 13.4135 13.0972 13.3337 13.3333 13.3337C13.5694 13.3337 13.7674 13.4135 13.9271 13.5732C14.0868 13.733 14.1667 13.9309 14.1667 14.167C14.1667 14.4031 14.0868 14.601 13.9271 14.7607C13.7674 14.9205 13.5694 15.0003 13.3333 15.0003ZM3.75 18.3337C3.41667 18.3337 3.125 18.2087 2.875 17.9587C2.625 17.7087 2.5 17.417 2.5 17.0837V4.16699C2.5 3.83366 2.625 3.54199 2.875 3.29199C3.125 3.04199 3.41667 2.91699 3.75 2.91699H5.10417V1.66699H6.45833V2.91699H13.5417V1.66699H14.8958V2.91699H16.25C16.5833 2.91699 16.875 3.04199 17.125 3.29199C17.375 3.54199 17.5 3.83366 17.5 4.16699V17.0837C17.5 17.417 17.375 17.7087 17.125 17.9587C16.875 18.2087 16.5833 18.3337 16.25 18.3337H3.75ZM3.75 17.0837H16.25V8.12533H3.75V17.0837ZM3.75 6.87533H16.25V4.16699H3.75V6.87533ZM3.75 6.87533V4.16699V6.87533Z" fill="white"/>
                                            </svg>
                                        </div>
                                        <input v-model="form.createdAt.value" :disabled="true" placeholder="12/04/2023" class="placeholder-[#9E9E9E] pl-[35px] h-[40px] block border-none rounded bg-gray-black w-full text-sm text-theme-white disabled:bg-[#1C1D21]">
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div class="flex gap-3 xl:flex-row flex-col items-start mt-[35px] mb-4">
                            <div class="w-full xl:w-1/4">
                                <div :class="'input-wrapper flex flex-col' ">
                                    <label class="text-xs mb-1">ETA (optional)</label>
                                    <input v-if="$route.query.status=='completed' && !form.eta.value"  class="placeholder:text-white pointer-events-none  pl-3 h-[40px] block border-none rounded bg-[#1C1D21] w-full text-sm text-theme-white">
                                    <Datepicker v-else v-model="form.eta.value" inputFormat="yyyy-MM-dd" class="bg-[#1C1D21] pointer-events-none text-sm border-0 h-10 w-full rounded placeholder:text-white text-white" placeholder="-" /> 
                                </div>
                            </div>
                            <div v-if="$route.query.status==='completed'" class="w-full xl:w-1/4">
                                <div class="input-wrapper flex flex-col ">
                                    <p class="text-xs mb-1">Completed On</p>
                                    <div class="relative">
                                        <div class="absolute px-2 top-[10px]">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 11.667C9.76389 11.667 9.56597 11.5871 9.40625 11.4274C9.24653 11.2677 9.16667 11.0698 9.16667 10.8337C9.16667 10.5975 9.24653 10.3996 9.40625 10.2399C9.56597 10.0802 9.76389 10.0003 10 10.0003C10.2361 10.0003 10.434 10.0802 10.5937 10.2399C10.7535 10.3996 10.8333 10.5975 10.8333 10.8337C10.8333 11.0698 10.7535 11.2677 10.5937 11.4274C10.434 11.5871 10.2361 11.667 10 11.667ZM6.66667 11.667C6.43056 11.667 6.23264 11.5871 6.07292 11.4274C5.91319 11.2677 5.83333 11.0698 5.83333 10.8337C5.83333 10.5975 5.91319 10.3996 6.07292 10.2399C6.23264 10.0802 6.43056 10.0003 6.66667 10.0003C6.90278 10.0003 7.10069 10.0802 7.26042 10.2399C7.42014 10.3996 7.5 10.5975 7.5 10.8337C7.5 11.0698 7.42014 11.2677 7.26042 11.4274C7.10069 11.5871 6.90278 11.667 6.66667 11.667ZM13.3333 11.667C13.0972 11.667 12.8993 11.5871 12.7396 11.4274C12.5799 11.2677 12.5 11.0698 12.5 10.8337C12.5 10.5975 12.5799 10.3996 12.7396 10.2399C12.8993 10.0802 13.0972 10.0003 13.3333 10.0003C13.5694 10.0003 13.7674 10.0802 13.9271 10.2399C14.0868 10.3996 14.1667 10.5975 14.1667 10.8337C14.1667 11.0698 14.0868 11.2677 13.9271 11.4274C13.7674 11.5871 13.5694 11.667 13.3333 11.667ZM10 15.0003C9.76389 15.0003 9.56597 14.9205 9.40625 14.7607C9.24653 14.601 9.16667 14.4031 9.16667 14.167C9.16667 13.9309 9.24653 13.733 9.40625 13.5732C9.56597 13.4135 9.76389 13.3337 10 13.3337C10.2361 13.3337 10.434 13.4135 10.5937 13.5732C10.7535 13.733 10.8333 13.9309 10.8333 14.167C10.8333 14.4031 10.7535 14.601 10.5937 14.7607C10.434 14.9205 10.2361 15.0003 10 15.0003ZM6.66667 15.0003C6.43056 15.0003 6.23264 14.9205 6.07292 14.7607C5.91319 14.601 5.83333 14.4031 5.83333 14.167C5.83333 13.9309 5.91319 13.733 6.07292 13.5732C6.23264 13.4135 6.43056 13.3337 6.66667 13.3337C6.90278 13.3337 7.10069 13.4135 7.26042 13.5732C7.42014 13.733 7.5 13.9309 7.5 14.167C7.5 14.4031 7.42014 14.601 7.26042 14.7607C7.10069 14.9205 6.90278 15.0003 6.66667 15.0003ZM13.3333 15.0003C13.0972 15.0003 12.8993 14.9205 12.7396 14.7607C12.5799 14.601 12.5 14.4031 12.5 14.167C12.5 13.9309 12.5799 13.733 12.7396 13.5732C12.8993 13.4135 13.0972 13.3337 13.3333 13.3337C13.5694 13.3337 13.7674 13.4135 13.9271 13.5732C14.0868 13.733 14.1667 13.9309 14.1667 14.167C14.1667 14.4031 14.0868 14.601 13.9271 14.7607C13.7674 14.9205 13.5694 15.0003 13.3333 15.0003ZM3.75 18.3337C3.41667 18.3337 3.125 18.2087 2.875 17.9587C2.625 17.7087 2.5 17.417 2.5 17.0837V4.16699C2.5 3.83366 2.625 3.54199 2.875 3.29199C3.125 3.04199 3.41667 2.91699 3.75 2.91699H5.10417V1.66699H6.45833V2.91699H13.5417V1.66699H14.8958V2.91699H16.25C16.5833 2.91699 16.875 3.04199 17.125 3.29199C17.375 3.54199 17.5 3.83366 17.5 4.16699V17.0837C17.5 17.417 17.375 17.7087 17.125 17.9587C16.875 18.2087 16.5833 18.3337 16.25 18.3337H3.75ZM3.75 17.0837H16.25V8.12533H3.75V17.0837ZM3.75 6.87533H16.25V4.16699H3.75V6.87533ZM3.75 6.87533V4.16699V6.87533Z" fill="white"/>
                                            </svg>
                                        </div>
                                        <input :disabled="true" v-model="form.completedOn.value" placeholder="-" class="placeholder-[#9E9E9E] pl-[35px] h-[40px] block border-none rounded bg-gray-black w-full text-sm text-theme-white disabled:bg-[#1C1D21]">
                                    </div>
                                </div>
                            </div>
                            <div class="w-full xl:w-1/4"></div>
                            <div class="w-full xl:w-1/4"></div>
                        </div>
                        <div class="flex xl:flex-row flex-col items-start mt-[35px] mb-4">
                            <div class="w-full ">
                                <div :class="'input-wrapper flex flex-col' ">
                                    <label class="text-xs mb-1">Notes (optional)</label>
                                    <textarea v-if="$route.query.status=='completed' && !form.note.value" disabled value="-" class="placeholder-theme-878686 pl-3  block border-none rounded bg-[#1C1D21] w-full text-sm text-theme-white"></textarea>
                                    <textarea v-else v-model="form.note.value" placeholder="-" class="placeholder:text-white pointer-events-none text-white block border-none rounded bg-[#1C1D21] w-full text-sm text-theme-white " ></textarea>  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Selected products -->
                <div class=" px-[24px] max-w-full mb-20">
                    <div class="flex flex-col  shadow-xl box-border px-4 text-white  rounded py-4 bg-[#2B2C32] mb-4">
                        <h2 class="font-bold  ml-3 text-xl leading-6 mb-11 tracking-[0.15px]">Selected Products ({{activeProducts.length}})</h2>
                        <SearchProduct v-if="$route.query.status==='pending'" :payload="payload" @reload="reload" :disabled="$route.query.status!=='pending'" />

                        <!-- warnings -->
                        <div class="mb-6 " v-if="$route.query.status==='pending'">
                            <div v-if="variantInfo" class="bg-[#3E3834] xl:w-[930px] rounded px-4 py-2  flex flex-row items-center mb-2">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 12.75C9.2125 12.75 9.39063 12.6781 9.53438 12.5344C9.67813 12.3906 9.75 12.2125 9.75 12C9.75 11.7875 9.67813 11.6094 9.53438 11.4656C9.39063 11.3219 9.2125 11.25 9 11.25C8.7875 11.25 8.60938 11.3219 8.46563 11.4656C8.32188 11.6094 8.25 11.7875 8.25 12C8.25 12.2125 8.32188 12.3906 8.46563 12.5344C8.60938 12.6781 8.7875 12.75 9 12.75ZM9 9.75C9.2125 9.75 9.39063 9.67813 9.53438 9.53438C9.67813 9.39063 9.75 9.2125 9.75 9V6C9.75 5.7875 9.67813 5.60938 9.53438 5.46563C9.39063 5.32188 9.2125 5.25 9 5.25C8.7875 5.25 8.60938 5.32188 8.46563 5.46563C8.32188 5.60938 8.25 5.7875 8.25 6V9C8.25 9.2125 8.32188 9.39063 8.46563 9.53438C8.60938 9.67813 8.7875 9.75 9 9.75ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69688 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69688 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69688 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69688 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5Z" fill="#FCB852"/>
                                </svg>
                                <p class="text-[#E7A644] ml-3 mr-8">Some products have multiple variants, please check each product and select the variant you want to transfer.</p>
                                <svg @click="variantInfo = false" class="cursor-pointer hover:opacity-50" width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z" fill="white"/>
                                </svg>
                            </div>
                            <div v-if="lotInfo" class="bg-[#3E3834] xl:w-[710px] rounded px-4 py-2  flex flex-row items-center ">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 12.75C9.2125 12.75 9.39063 12.6781 9.53438 12.5344C9.67813 12.3906 9.75 12.2125 9.75 12C9.75 11.7875 9.67813 11.6094 9.53438 11.4656C9.39063 11.3219 9.2125 11.25 9 11.25C8.7875 11.25 8.60938 11.3219 8.46563 11.4656C8.32188 11.6094 8.25 11.7875 8.25 12C8.25 12.2125 8.32188 12.3906 8.46563 12.5344C8.60938 12.6781 8.7875 12.75 9 12.75ZM9 9.75C9.2125 9.75 9.39063 9.67813 9.53438 9.53438C9.67813 9.39063 9.75 9.2125 9.75 9V6C9.75 5.7875 9.67813 5.60938 9.53438 5.46563C9.39063 5.32188 9.2125 5.25 9 5.25C8.7875 5.25 8.60938 5.32188 8.46563 5.46563C8.32188 5.60938 8.25 5.7875 8.25 6V9C8.25 9.2125 8.32188 9.39063 8.46563 9.53438C8.60938 9.67813 8.7875 9.75 9 9.75ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69688 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69688 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69688 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69688 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5Z" fill="#FCB852"/>
                                </svg>
                                <p class="text-[#E7A644] ml-3 mr-8">Lot tracking is enabled, please select the specific LOT you would like to transfer.</p>
                                <svg @click="lotInfo = false" class="cursor-pointer hover:opacity-50" width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z" fill="white"/>
                                </svg>
                            </div>
                        </div>

                        <ProductList :products="activeProducts" :selected="selected" :selectedProduct="selectedProducts" @deleteReload="deleteReload" />
                    </div>
                </div>
            </div>
        </div>
        <Warning :status="invalidPopup" @close="invalidPopup=false" />
    </div>
</template>
<script>
import {defineComponent, ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/helpers';
import TransferHelper from '@/helpers/transfer';
import { useSnackbar } from "vue3-snackbar";
import TransferApi from '@/controllers/Transfer'
import ProductList from "@/views/Inventory/Transfer/transfer/ProductList.vue"
import SearchProduct from "@/views/Inventory/Transfer/transfer/SearchProduct.vue"
import Warning from '@/views/Inventory/Transfer/transfer/Warning.vue'
import Datepicker from 'vue3-datepicker'
import moment from 'moment'
import product from "@/helpers/product";

export default defineComponent({
  name: "InventoryTransfer",
  components: {
    Datepicker,
    SearchProduct,
    ProductList,
    Warning
  },

  setup() {
    const loading = ref(false)
    const error =ref(false)
    const invalidPopup = ref(false)
    const manualSave = ref(false)
    const snackbar = useSnackbar();
    const action = ref({
      component: '',
      data: [],
    });
    const payload = ref({transferProducts:[]})
    const form = ref({
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      fromLocationId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      toLocationId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      eta: {
        value: null
      },
      note: {
        value: ''
      },
      status: {
        value: 'shipped'
      },
      createdAt: {
        value: ''
      },
      completedOn: {
        value: ''
      }
    });
    const variantInfo = ref(true)
    const lotInfo =ref(true)
    const selected = ref([])
    const selectedProducts = ref([])
    const activeProducts = ref([])

    return {
      loading,
      error,
      invalidPopup,
      manualSave,
      form,
      payload,
      snackbar,
      action,
      variantInfo,
      lotInfo,
      selected,
      selectedProducts,
      activeProducts
    };
  },

  computed: {
    /**
     * Edit restriction
     */
    can_edit_membership_details() {
      return Helpers.getMyPermission('can_edit_membership_details')
    },
    ...mapGetters({
        vg_locations: 'location/list',
        vg_selectedLocation: 'location/selected',
    }),
  },

  async mounted() {
    this.error = false
    if(this.$route.params.id && this.$route.query.locationId){
        if(this.$route.query.status==='shipped'){
            this.form.status.value = 'shipped transfer'
        }else if(this.$route.query.status==='completed'){
            this.form.status.value = 'completed transfer'
        }else{
            this.form.status.value = this.$route.query.status
        }
        this.loading = true
        await this.getData()
        this.loading = false
    }else{
        this.error = true
    }
  },

  watch: {
    'vg_selectedLocation'(val) {
      this.$router.push('/inventory-transfer')
    },
    "form.fromLocationId.value"(val){
        if(val===this.form.toLocationId.value){
            this.form.toLocationId.value = ''
        }
    },
    "form.status.value"(){
        this.checkAllValidity()
    },
    '$route.query.status'(status){
        if(status==='shipped'){
            this.form.status.value = 'completed transfer'
            this.getData()
        }
    }
  },
  beforeUnmount(){
    if(this.payload.status!=='completed' && this.payload.status!=='completed transfer' && this.payload.status!=='shipped transfer'){
        if(!this.manualSave){
            this.saveOnly(false)
        }
    }
  },

  methods: {
    formatDate(date){
        if(!date) return
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    },
    async getData(){
        let res = await TransferApi.getTransfer(this.$route.params.id, this.$route.query.locationId, this.$route.query.toLocationId)
        if(res.data?.payload){
            this.payload = res.data.payload
            this.form.name.value = this.payload.name
            this.form.fromLocationId.value = this.payload.fromLocationId
            this.form.toLocationId.value = this.payload.toLocationId
            this.form.eta.value = this.payload.eta?moment(this.payload.eta).toDate():null
            this.form.note.value = this.payload.note
            this.form.createdAt.value = this.payload.createdAt?this.formatDate(this.payload.createdAt):null
            this.form.completedOn.value = this.payload.completedOn?this.formatDate(this.payload.completedOn):null

            // get activeProducts: enabled 
            this.activeProducts = []
            this.getActiveProducts(this.payload.transferProducts)

            this.selected = []
            this.selectedProducts = []
            for(let i=0; i<this.payload.transferProducts.length; i++){
                // get selected main variant id
                if(this.isSelected(this.payload.transferProducts[i])){
                    this.selectedProducts.push(this.payload.transferProducts[i].id)
                }
                this.getVariant(this.payload.transferProducts[i])
                for(let j=0; j<this.payload.transferProducts[i].transferVariants.length; j++){
                    this.getVariant(this.payload.transferProducts[i].transferVariants[j])
                }
            }
        }else{
            this.error = true
        }
    },
    async reload(){
        let res = await TransferApi.getTransfer(this.$route.params.id, this.$route.query.locationId, this.$route.query.toLocationId)
        if(res.data?.payload){
            this.payload = res.data.payload
            let activeProductIds = this.activeProducts.map(each => each.id)
            let addedProducts = []
            for(let i=0; i<res.data?.payload?.transferProducts?.length; i++){
                if(!activeProductIds.includes(res.data?.payload?.transferProducts[i].id)){
                    addedProducts.push(res.data?.payload?.transferProducts[i])
                }
            }

            // added added products to active product list
            this.activeProducts = [...this.activeProducts, ...addedProducts]

            // added selection list
            for(let i=0; i<addedProducts.length; i++){
                this.getVariant(addedProducts[i])
                for(let j=0; j<addedProducts[i].transferVariants.length; j++){
                    this.getVariant(addedProducts[i].transferVariants[j])
                }
            }

        }
    },
    async deleteReload(deletedId){
        let productMainAndVariantIds = []
        let productIndex = this.activeProducts.findIndex(each => each.id==deletedId)
        if(productIndex>=0){
            let productVariantIds = this.activeProducts[productIndex].transferVariants.map(each => each.id)
            productMainAndVariantIds = [deletedId, ...productVariantIds]
            this.activeProducts.splice(productIndex, 1)
            this.payload.transferProducts = this.activeProducts
        }
        
        // remove from selected
        for(let i=0; i<productMainAndVariantIds.length; i++){
            let selectedIndex = this.selected.findIndex(each => each.transferProductId==productMainAndVariantIds[i])
            if(selectedIndex>=0){
                this.selected.splice(selectedIndex, 1)
            }   
        }

        // remove from selectedProduct
        let selectedProductIndex = this.selectedProducts.findIndex(each => each==deletedId)
        if(selectedProductIndex>=0){
            this.selectedProducts.splice(selectedProductIndex, 1)
        }
    },
    isSelected(product){
        // if not variant and no batches
        if(product.transferBatches.length==0 && product.transferVariants.length==0){
            return product.isSelected
        }

        let showProduct = false
        let showVariant = false
        let allBatchesInactive = false
        let allSubVariantInActive = false
        // product with batches
        if(product.transferBatches.length>0){
            // show product if some batch is selected
            showProduct = product.transferBatches.some(each => each.isSelected)
        }else{
            allBatchesInactive = true
        }
        // variant with batches
        if(product.transferVariants.length>0){
            // show product if some variant some batch is selected
            showVariant = product.transferVariants.some(variant => variant.transferBatches.length==0 || variant.transferBatches.some(each => each.isSelected))
        }else{
            allSubVariantInActive = true
        }

        if(allBatchesInactive && allSubVariantInActive){
            return false
        }else{
            return showProduct || showVariant
        }
    },
    getActiveProducts(products){
        this.activeProducts = []
        if(this.form.status.value==='pending'){
            this.activeProducts = [...products]
        }else{
            for(let i=0; i<products.length; i++){
                let allBatchesInactive = false
                let allSubVariantInActive = false
                if(products[i].transferBatches.length>0){
                    // show product if some batch is selected
                    allBatchesInactive = products[i].transferBatches.some(each => each.isSelected)
                }else{
                    allBatchesInactive = true
                }
                if(products[i].transferVariants.length>0){
                    // show product if some variant some batch is selected
                    allSubVariantInActive = products[i].transferVariants.some(variant => variant.transferBatches.some(each => each.isSelected))
                }else{
                    allSubVariantInActive = true
                }

                if(allBatchesInactive || allSubVariantInActive){
                    this.activeProducts.push(products[i])
                }
            }
        }
    },
    getVariant(variant){
        let obj = {
            transferProductId: variant.id,
            transferQty: variant.transferQty ? variant.transferQty : null,
            actualTransferQty: variant.actualTransferQty ? variant.actualTransferQty : null,
            isSelected: variant.isSelected
        }
        if(variant.transferBatches?.length>0){
            obj.batches = []
            for(let j=0; j<variant.transferBatches.length; j++){
                obj.batches.push({
                    availableQty: variant.transferBatches[j]?.actualBatch?.current_nou,
                    transferBatchId: variant.transferBatches[j].id,
                    transferQty: variant.transferBatches[j].transferQty ? variant.transferBatches[j].transferQty : null,
                    isSelected: variant.transferBatches[j].isSelected
                })
            }
            obj.isSelected = variant.transferBatches.some(each => each.isSelected)
        }else{
            obj.availableQty = variant.actualProductStock?.activeStock
        }
        this.selected.push(obj)
    },
    async saveAndGoBack(){
        if(this.payload.status!=='completed' && this.payload.status!=='completed transfer' && this.payload.status!=='shipped transfer'){
            this.manualSave = true
            if(await this.saveOnly()){
                this.$router.push('/inventory-transfer')
            }
        }else{
            this.$router.push('/inventory-transfer')
        }
    },
    goBack(){
        this.manualSave = true
        this.$router.push('/inventory-transfer')
    },
    clearComponent() {
      this.action = {
        component: '',
        data: [],
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
        let subGroup = document.getElementsByClassName('active-sub-row')
        Array.from(subGroup).forEach((item) => {
          item.classList.remove('active-sub-row')
        })
      }
    },
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      this.form = res.data;
      return res.error ? false : true;
    },
    async checkAllValidity(){
        if(!this.loading){
            let validate = await this.validateFields(['name', 'fromLocationId', 'toLocationId']);
            if(!validate) {
                this.form.status.value = 'pending'
                return false;
            }else{
                let someInvalidValue = false
                for(let i=0; i<this.selected.length; i++){
                    if(this.selected[i].batches){
                        // either isSelected false or transferQty>0 and less than availableQty
                        let allBatchValid = this.selected[i].batches.every(each => !each.isSelected || (each.transferQty!=0 && each.availableQty>=each.transferQty))
                        if(!allBatchValid) someInvalidValue = true
                    }else{
                        let allBatchValid = !this.selected[i].isSelected || (this.selected[i].transferQty!=0 && this.selected[i].availableQty>=this.selected[i].transferQty)
                        if(!allBatchValid){
                            someInvalidValue = true
                        }
                    }
                }
                if(someInvalidValue){
                    this.form.status.value = 'pending'
                    this.invalidPopup = true
                    return false
                }
            }
            return true
        }
    },
    async saveOnly(redirect=true){
        if(await this.checkAllValidity()){
            this.va_spinner(true)
            let selectedFromLocation = this.vg_locations.find(each => each.id===this.form.fromLocationId.value)
            let selectedToLocation = this.vg_locations.find(each => each.id===this.form.toLocationId.value)
            let etaDate = this.form.eta.value?moment(this.form.eta.value).format('YYYY-MM-DD'):null
            let data = {
                name: this.form.name.value,
                fromLocationId: this.form.fromLocationId.value,
                fromLocationName: selectedFromLocation?selectedFromLocation.name:'',
                toLocationId: this.form.toLocationId.value,
                toLocationName: selectedToLocation?selectedToLocation.name:'',
                status: 'pending',
                eta: etaDate,
                note: this.form.note.value
            }
            let res1 = await TransferApi.bulkUpdate({transferId: this.payload.id, transferProducts: this.selected})
            if(res1.status!==200){
                this.snackbar.add({
                    type: 'info',
                    text: Helpers.catchErrorMessage(res1.response.data),
                    duration: 3000,
                })
                this.va_spinner(false)
                return false
            }
            let res = await TransferApi.updateTransfer(this.payload.id, data)
            if(res.status===200){
                this.snackbar.add({
                    type: 'info',
                    text: "Transfer saved",
                    duration: 3000,
                })
                this.va_spinner(false)
                return true
            }else{
                this.snackbar.add({
                    type: 'info',
                    text: "Something went wrong",
                    duration: 3000,
                })
                this.va_spinner(false)
                return false
            }
        }else{
            return false
        }
    },
    async save(){
        this.manualSave = true
        if(await this.checkAllValidity()){
            if(this.form.status.value!=='pending' && this.selected.length>0 && this.selectedProducts.length===this.payload.transferProducts.length){
                this.va_spinner(true)
                let selectedFromLocation = this.vg_locations.find(each => each.id===this.form.fromLocationId.value)
                let selectedToLocation = this.vg_locations.find(each => each.id===this.form.toLocationId.value)
                let etaDate = this.form.eta.value?moment(this.form.eta.value).format('YYYY-MM-DD'):null
                let data = {
                    name: this.form.name.value,
                    fromLocationId: this.form.fromLocationId.value,
                    fromLocationName: selectedFromLocation?selectedFromLocation.name:'',
                    toLocationId: this.form.toLocationId.value,
                    toLocationName: selectedToLocation?selectedToLocation.name:'',
                    status: this.form.status.value,
                    eta: etaDate,
                    note: this.form.note.value
                }
                if(this.$route.query.status && this.$route.query.status==='pending'){
                    // change batches with isSelected false to transfer Qty 0
                    let selectedTransfers = [...this.selected]
                    for(let i=0; i<selectedTransfers.length; i++){
                        if(selectedTransfers[i].batches){
                            let bachesTotal = 0
                            for(let j=0; j<selectedTransfers[i].batches.length; j++){
                                if(!selectedTransfers[i].batches[j].isSelected){
                                    selectedTransfers[i].batches[j].transferQty = 0
                                }else{
                                    bachesTotal += selectedTransfers[i].batches[j].transferQty
                                }
                            }
                            selectedTransfers[i].transferQty = bachesTotal
                        }else{
                            // change transferQty to 0 if isSelected is false
                            if(!selectedTransfers[i].isSelected){
                                selectedTransfers[i].transferQty = 0
                            }
                        }
                    }
                    await TransferApi.bulkUpdate({transferId: this.payload.id, transferProducts: selectedTransfers})
                }
                let res = await TransferApi.updateTransfer(this.payload.id, data)
                if(res.status===200){
                    this.snackbar.add({
                        type: 'info',
                        text: "Transfer updated successfully",
                        duration: 3000,
                    })
                    this.va_spinner(false)
                    this.$router.push('/inventory-transfer')
                    return true
                }else{
                    this.snackbar.add({
                        type: 'info',
                        text: "Something went wrong",
                        duration: 3000,
                    })
                    this.va_spinner(false)
                    return false
                }
            }else{
                let msg = ''
                if(this.form.status.value==='pending'){
                    msg = "Please change status"
                }else if(this.selected.length===0){
                    msg = "Please add products"
                }else if(this.selectedProducts.length!==this.payload.transferProducts.length){
                    msg = "Please add all products"
                }
                this.snackbar.add({
                    type: 'info',
                    text: msg,
                    duration: 3000,
                })
                this.va_spinner(false)
                return false
            }
        }else{
            return false
        }
    },
    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
  },
});

</script>
<style>
.v3dp__datepicker{
    display: flex;
    flex-direction: row;
}
</style>
